import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import ABCyaLib from '@abcya/abcya_lib';

export default class NavBar extends AContainer {
  constructor(scene, tweenIn = false) {
    super(scene);
    this.tweenIn = tweenIn;
    this.alarmPlaying = false;

    this.createBar();
    this.createRoundBar();
    this.createFillBar();

    this.tweenInNav();
  }

  createBar() {
    this.barCont = this.scene.add.container();
    this.soundCont = this.scene.add.container();

    this.alarmCounter = 3;
    this.alarmBG = this.scene.addImage(this.scene.mid.x, 153, "AlarmOverlay", this.scene.defaultAtlas);
    this.bg = this.scene.addImage(0, 0, "UINavBar", this.scene.defaultAtlas);
    this.menu = this.scene.addImage(357, -10, "MenuBtn", this.scene.defaultAtlas);
    this.sound = this.scene.addImage(0, 0, "MuteBtn", this.scene.defaultAtlas);
    this.mute = this.scene.addImage(0, 0, "UnmuteBtn", this.scene.defaultAtlas);
    this.alarmOn = this.scene.addImage(-63, 33, "AlarmLit", this.scene.defaultAtlas);
    this.alarmLight1 = this.scene.addImage(-60, 40, "AlarmLight", this.scene.defaultAtlas);
    this.alarmLight2 = this.scene.addImage(-60, 40, "AlarmLight", this.scene.defaultAtlas);
    if (this.tweenIn) {
      this.alarmOff = this.scene.addImage(-62, 0, "AlarmUnlit", this.scene.defaultAtlas);
    } else {
      this.alarmOff = this.scene.addImage(-62, 22, "AlarmUnlit", this.scene.defaultAtlas);
    }

    this.menu.on("pointerup", () => { this.scene.pauseGame(); });
    this.mute.on("pointerup", () => { this.toggleMute(); });
    this.sound.on("pointerup", () => { this.toggleMute(); });

    this.mute.name = "sound";
    this.sound.name = "sound";

    this.add(this.barCont);
    this.barCont.add([this.alarmOff, this.bg, this.menu, this.soundCont, this.alarmLight1, this.alarmLight2, this.alarmOn]);
    this.soundCont.add([this.mute, this.sound]);

    this.alarmOn.alpha = 0;
    this.alarmBG.alpha = 0;
    this.alarmLight1.alpha = 0;
    this.alarmLight2.alpha = 0;
    this.alarmLight2.scaleX = -1;
    if (!gameData.gameMuted) {
      this.sound.visible = false;
    }
    else {
      this.mute.visible = false;
    }

    if (this.tweenIn) {
      this.barCont.setPosition(-450, this.bg.height / 2 - 1);
    } else {
      this.barCont.setPosition(575, this.bg.height / 2 - 1);
    }
    this.soundCont.setPosition(228, -10);

    this.lights = [];
    for (let n = 0; n < 10; n++) {
      let lightBG = this.scene.addImage(-265 + (n * 37), -35, "UILightUnlit", this.scene.defaultAtlas);
      let light = this.scene.addImage(-265 + (n * 37), -37, "UILightLit", this.scene.defaultAtlas);
      this.barCont.add([lightBG, light]);

      if (gameData.round === 1) light.alpha = 0;

      this.lights.push(light);
    }
  }

  createRoundBar() {
    this.roundCont = this.scene.add.container();
    this.add(this.roundCont);

    this.roundOuter = this.scene.addImage(0, 0, "UIGearOutside", this.scene.defaultAtlas);
    this.roundInner = this.scene.addImage(0, 0, "UIGearInside", this.scene.defaultAtlas);
    this.roundHand = this.scene.addImage(0, 0, "UIGearHand", this.scene.defaultAtlas);
    this.roundCont.add([this.roundOuter, this.roundInner, this.roundHand]);

    this.round = ABCyaPhaser.Text.addCurvedText(-8, -8, 26, 0xe2d4bc, FontKeys._gantonregular, ABCyaPhaser.Localization.instance.getLocalizedString('round'), 80, this.roundCont, 1.3, 1, false);
    this.roundCont.moveAbove(this.roundHand, this.round)

    if (this.tweenIn) {
      this.roundHand.setAngle(-180);
      this.roundInner.setAngle(90);
      this.round.setAngle(90);
      this.roundCont.setPosition(-this.roundOuter.width / 2, -this.roundOuter.height / 2);
    } else {
      if (gameData.round === 3) this.roundHand.setAngle(-35);
      this.roundCont.setPosition(30, 30);
    }
  }

  createFillBar() {
    this.fillCont = this.scene.add.container();
    this.add(this.fillCont);

    this.fillBG = this.scene.addImage(0, 0, "FuelGaugeEmpty", this.scene.defaultAtlas);
    let bottom = this.scene.addImage(-7, 140, "FuelFillTopDark", this.scene.defaultAtlas);
    this.fill = this.scene.addImage(-9, 140, "FuelGaugeFill", this.scene.defaultAtlas);
    let overlay = this.scene.addImage(-7, 0, "FuelGaugeOverlay", this.scene.defaultAtlas);
    this.top = this.scene.addImage(-7, 140, "FuelFillTopDark", this.scene.defaultAtlas);

    this.fillCont.add([this.fillBG, bottom, this.fill, this.top, overlay]);

    if (this.tweenIn) {
      this.fill.scaleY = 0;
      this.fillCont.setPosition(1024 + this.fillBG.width / 2, this.scene.mid.y);
    } else {
      this.top.y = 113;
      this.top.scaleY = 0;
      this.fillCont.setPosition(1024 - this.fillBG.width / 2 + 10, this.scene.mid.y);
    }
  }

  updateLevel() {
    gameData.score++;

    for (let n = 0; n < gameData.score; n++) {
      this.tweenInLight(this.lights[n]);
    }

    if (gameData.round !== 2) this.tweenFill();

    if (gameData.score >= 10) {
      gameData.round++;
      gameData.gameOver = true;

      if (gameData.round === 2) {
        this.scene.addTween(this.roundHand, 2500, { angle: -35 }, Phaser.Math.Easing.Elastic.Out);

        for (let n = 0; n < this.lights.length; n++) {
          this.scene.addTween(this.lights[n], 1000, { alpha: 0 }, Phaser.Math.Easing.None);
        }

        this.scene.largePortal.clearPortal();
      }
      else if (gameData.round === 3) {
        this.scene.addTween(this.roundHand, 2500, { angle: -70 }, Phaser.Math.Easing.Elastic.Out);

        for (let n = 0; n < this.lights.length; n++) {
          this.scene.addTween(this.lights[n], 1000, { alpha: 0 }, Phaser.Math.Easing.None);
        }

        this.scene.largePortal.clearPortal();
      }
      else if (gameData.round === 4) {
        this.scene.endGame();
      }
    }
  }

  turnOnAlarm() {
    this.alarmPlaying = true;

    this.alarmBG.alpha = 1;
    this.alarmOn.alpha = 1;
    this.alarmLight1.alpha = 1;
    this.alarmLight2.alpha = 1;
    this.alarmLight1.setScale(-1, 1);
    this.alarmLight2.setScale(1, 1);

    this.scene.killTween(this.alarmLight1);
    this.scene.killTween(this.alarmLight2);

    this.tweenAlarmLightsIn();
  }

  turnOffAlarm() {
    this.alarmPlaying = false;

    this.alarmCounter = 3;
    this.alarmBG.alpha = 0;
    this.alarmOn.alpha = 0;
    this.alarmLight1.alpha = 0;
    this.alarmLight2.alpha = 0;

    if (gameData.round === 3) {
      if(!this.scene || !this.scene.smallPortal) return;

      this.scene.smallPortal.changeWord();
    }
  }

  tweenAlarmLightsIn() {
    if (this.alarmCounter > 0) {
      if (this.alarmLight1.scaleX === -1) {
        this.scene.addTween(this.alarmLight1, 500, { scaleX: 0, scaleY: 2 }, Phaser.Math.Easing.None);
        this.scene.addTween(this.alarmLight2, 500, { scaleX: 0, scaleY: .5 }, Phaser.Math.Easing.None,
          () => { this.tweenAlarmLightsOut(); });
      } else {
        this.scene.addTween(this.alarmLight1, 500, { scaleX: 0, scaleY: .5 }, Phaser.Math.Easing.None);
        this.scene.addTween(this.alarmLight2, 500, { scaleX: 0, scaleY: 2 }, Phaser.Math.Easing.None,
          () => { this.tweenAlarmLightsOut(); });
      }
    } else {
      if (this.alarmPlaying) this.turnOffAlarm();
    }
  }

  tweenAlarmLightsOut() {
    this.alarmCounter--;

    if (this.alarmLight1.scaleY === .5) {
      this.scene.addTween(this.alarmLight1, 500, { scaleX: -1, scaleY: 1 }, Phaser.Math.Easing.None);
      this.scene.addTween(this.alarmLight2, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.None,
        () => { this.tweenAlarmLightsIn(); });
    } else {
      this.scene.addTween(this.alarmLight1, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.None);
      this.scene.addTween(this.alarmLight2, 500, { scaleX: -1, scaleY: 1 }, Phaser.Math.Easing.None,
        () => { this.tweenAlarmLightsIn(); });
    }
  }

  tweenRoundBar() {
    let randAngle = Phaser.Math.Between(0, 180);
    let randTime = Phaser.Math.Between(5000, 15000);
    this.scene.addTween(this.roundOuter, randTime, { angle: randAngle }, Phaser.Math.Easing.Quadratic.InOut,
      () => { this.tweenRoundBar() });
  }

  tweenInNav() {
    if (gameData.round === 1) {
      this.scene.addTween(this.roundHand, 1500, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out);
      this.scene.addTween(this.roundInner, 1000, { angle: 0 }, Phaser.Math.Easing.Back.Out);
      this.scene.addTween(this.round, 1000, { angle: 0 }, Phaser.Math.Easing.Back.Out);
      this.scene.addTween(this.roundOuter, 1500, { angle: 180 }, Phaser.Math.Easing.Back.Out,
        () => {
          this.enableButtons();
          this.tweenRoundBar();
        });
      this.scene.addTween(this.roundCont, 1000, { x: 30, y: 30 }, Phaser.Math.Easing.Back.Out);

      this.scene.addTween(this.barCont, 1500, { x: 575 }, Phaser.Math.Easing.Quadratic.Out);
      this.scene.addTween(this.alarmOff, 1000, { y: 22, delay: 500 }, Phaser.Math.Easing.Quadratic.Out);
      this.scene.addTween(this.fillCont, 1500, { x: 1024 - this.fillBG.width / 2 + 10 }, Phaser.Math.Easing.Quadratic.Out);
    }
    else if (gameData.round === 2) {
      this.scene.addTween(this.roundHand, 1500, { angle: -35 }, Phaser.Math.Easing.Elastic.Out,
        () => {
          this.enableButtons();
          this.tweenRoundBar();
        });

      for (let n = 0; n < this.lights.length; n++) {
        this.scene.addTween(this.lights[n], 500, { alpha: 0 }, Phaser.Math.Easing.None);
      }
    }
    else if (gameData.round === 3) {
      this.scene.addTween(this.roundHand, 1500, { angle: -70 }, Phaser.Math.Easing.Quadratic.Out,
        () => {
          this.enableButtons();
          this.tweenRoundBar();
        });

      for (let n = 0; n < this.lights.length; n++) {
        this.scene.addTween(this.lights[n], 500, { alpha: 0 }, Phaser.Math.Easing.None);
      }
    }
  }

  tweenOutNav() {
    this.scene.addTween(this.roundCont, 1500, { x: -this.roundOuter.width / 2 }, Phaser.Math.Easing.Back.Out);
    this.scene.addTween(this.barCont, 1500, { x: -this.barCont.width / 2 - this.roundOuter.width }, Phaser.Math.Easing.Quadratic.Out);
    this.scene.addTween(this.fillCont, 1500, { x: 1024 + this.fillBG.width / 2 }, Phaser.Math.Easing.Quadratic.Out);
  }

  tweenInLight(light) {
    if (light.alpha === 0) {
      this.scene.addTween(light, 500, { alpha: 1 }, Phaser.Math.Easing.None);
    }
  }

  enableButtons() {
    this.menu.setInteractive();
    this.sound.setInteractive();
    this.mute.setInteractive();
  }

  disableButtons() {
    this.menu.disableInteractive();
    this.sound.disableInteractive();
    this.mute.disableInteractive();
  }

  tweenFill() {
    let adj;
    let fillY;
    let scaleAdj;
    let lvlAdj;

    if (gameData.round !== 3) {
      adj = gameData.score / 10;
      lvlAdj = gameData.score;
    } else {
      adj = (10 - gameData.score) / 10;
      lvlAdj = 10 - gameData.score;
    }

    if (lvlAdj === 0) {
      fillY = 140;
      scaleAdj = 1;
    }
    else if (lvlAdj === 1) {
      fillY = 113;
      scaleAdj = .9;
    }
    else if (lvlAdj === 2) {
      fillY = 85;
      scaleAdj = .8;
    }
    else if (lvlAdj === 3) {
      fillY = 56;
      scaleAdj = .7;
    }
    else if (lvlAdj === 4) {
      fillY = 28;
      scaleAdj = .6;
    }
    else if (lvlAdj === 5) {
      fillY = 0;
      scaleAdj = .5;
    }
    else if (lvlAdj === 6) {
      fillY = -29;
      scaleAdj = .4;
    }
    else if (lvlAdj === 7) {
      fillY = -58;
      scaleAdj = .3;
    }
    else if (lvlAdj === 8) {
      fillY = -86;
      scaleAdj = 0;
    }
    else if (lvlAdj === 9) {
      fillY = 113;
      scaleAdj = 0;
    }
    else if (lvlAdj === 10) {
      fillY = 113;
      scaleAdj = 0;
    }

    this.scene.addTween(this.top, 1000, { y: fillY, scaleY: scaleAdj }, Phaser.Math.Easing.Quadratic.Out);
    this.scene.addTween(this.fill, 1000, { scaleY: adj }, Phaser.Math.Easing.Quadratic.Out);
  }

  toggleMute() {
    if (!gameData.gameMuted) {
      this.scene.playSound("click");

      this.scene.sound.setVolume(0);

      this.mute.visible = false;
      this.sound.visible = true;

      this.mute.disableInteractive();
      this.sound.setInteractive();

      gameData.gameMuted = true;
    } else {
      this.scene.sound.setVolume(1);

      this.mute.visible = true;
      this.sound.visible = false;

      this.sound.disableInteractive();
      this.mute.setInteractive();

      gameData.gameMuted = false;
    }
  }

  cleanUp() {
    this.scene.killTween(this.roundOuter);
  }
}